import axios from './axios';
import { SocialSkill } from '../types';

interface SocialSkillData {
  text: string;
  order: number;
}

export const getSocialSkills = async (): Promise<SocialSkill[]> => {
  const response = await axios.get('/admin/social-skills');
  return response.data;
};

export const createSocialSkill = async (data: SocialSkillData): Promise<SocialSkill> => {
  const response = await axios.post('/admin/social-skills', data);
  return response.data;
};

export const updateSocialSkill = async (id: number, data: SocialSkillData): Promise<SocialSkill> => {
  const response = await axios.put(`/admin/social-skills/${id}`, data);
  return response.data;
};

export const deleteSocialSkill = async (id: number): Promise<void> => {
  await axios.delete(`/admin/social-skills/${id}`);
};
